import dayjs from 'dayjs';
import * as _ from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n-lite';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import * as html2pdf from 'js-html2pdf';
import { isFuture } from '../../utils/dateUtlis';
import AssignmentCard from './AssignmentsCard';
import AssignmentsContent from './AssignmentsContent';
import * as bookActions from '../../actions/bookActions';
import * as taskActions from '../../actions/taskActions';
import * as drawerActions from '../../actions/drawerActions';
import * as taskService from '../../services/domain/taskService';
import { DRAWER_CONTENTS, TASK_TABS_CONSTANTS, ROLE } from '../../const';
import * as classroomActions from '../../actions/classroom/classroomActions';
import * as assignmentsDrawerActions from '../../actions/assignmentsDrawerActions';
import * as classroomGroupsActions from '../../actions/classroom/classroomGroupActions';
import * as groupsApi from '../../services/api/groupApi';
import { resultActivitiesStudents } from '../../utils/gradeUtils';
import * as messageAlert from '../../actions/messageAlertAction';
import $ from 'jquery';
import { ExportToCsv } from 'export-to-csv';
import { format } from 'date-fns';

export class Assignments extends Component {
  state = {};
  static propTypes = {
    messageAlert: PropTypes.any
  };
  isTeacher = () => this.props.role === ROLE.INSTRUCTOR;

  componentDidMount() {
    const { role, taskActions } = this.props;

    Promise.all([
      taskActions.setCurrentTasksCurrentPage(0),
      taskActions.setFinishedTasksCurrentPage(0),
      taskActions.setFutureTasksCurrentPage(0)
    ]).then(() => {
      this.getTasks();
    });

    if (role === ROLE.INSTRUCTOR) {
      this.getClassroomGroups();
    }
  }

  shouldComponentUpdate(nextProps) {
    const { keywordsFilter, datesRangeFilter } = this.props;
    const nextKeywordsFilter = nextProps.keywordsFilter;
    const nextDatesRangeFilter = nextProps.datesRangeFilter;

    if (nextDatesRangeFilter && nextDatesRangeFilter.endDate) {
      if (datesRangeFilter && datesRangeFilter.endDate) {
        const nextEndDate = format(nextDatesRangeFilter.endDate, 'dd/MM/yyyy');
        const endDate = format(datesRangeFilter.endDate, 'dd/MM/yyyy');
        if (nextEndDate !== endDate) {
          this.getTasks();
        }
      } else {
        this.getTasks();
      }
    }
    if (nextKeywordsFilter) {
      if (keywordsFilter) {
        if (nextKeywordsFilter !== keywordsFilter) {
          this.getTasks();
        }
      } else {
        this.getTasks();
      }
    } else if (keywordsFilter) {
      this.getTasks();
    }
    return true;
  }

  componentWillUnmount() {
    const { classroomId, classroomActions, taskActions, tab } = this.props;
    if (classroomId) {
      if (tab) {
        switch (tab.key) {
          case TASK_TABS_CONSTANTS.IN_PROGRESS.key:
            taskActions.setCurrentTasks();
            taskActions.setCurrentTasksPages();
            break;
          case TASK_TABS_CONSTANTS.FINISHED.key:
            taskActions.setFinishedTasks();
            taskActions.setFinishedTasksPages();
            break;
          case TASK_TABS_CONSTANTS.FUTURE.key:
            taskActions.setFutureTasks();
            taskActions.setFutureTasksPages();
            break;
          default:
            taskActions.setFilteredTasks();
            taskActions.setFilteredTasksPages();
            break;
        }
      }
      classroomActions.setClassroomGroups();
    }
  }

  getTasks = () => {
    const { classroomId, taskActions, tab, user } = this.props;

    if (tab) {
      switch (tab.key) {
        case TASK_TABS_CONSTANTS.IN_PROGRESS.key:
          taskActions.getCurrentAssignments(classroomId, user._id);
          break;
        case TASK_TABS_CONSTANTS.FINISHED.key:
          taskActions.getFinishedAssignments(classroomId, user._id);
          break;
        case TASK_TABS_CONSTANTS.FUTURE.key:
          taskActions.getFutureAssignments(classroomId, user._id);
          break;
        default:
          taskActions.getFilteredAssignments(
            classroomId,
            user._id,
            null,
            classroomId ? undefined : TASK_TABS_CONSTANTS.IN_PROGRESS
          );
          break;
      }
    }
  };

  getClassroomGroups = () => {
    const { classroom, classroomGroupsActions } = this.props;
    classroomGroupsActions.getClassroomGroups(classroom.id);
  };

  toggleEditAssignment = task => {
    const { drawerActions, taskActions } = this.props;

    taskActions.setSelectedTask(task);
    drawerActions.openDrawerAndSetContent(DRAWER_CONTENTS.DETAIL_ASSIGNMENTS);
  };

  closeTask = task => {
    const { assignmentsDrawerActions, classroomId } = this.props;
    const assignment = {
      wording: task.wording,
      startDate: task.startDate,
      dueDate: dayjs(),
      title: task.name,
      allowFile: task.allowFileResponse,
      allowUserComment: task.allowUserCommentResponse,
      allowExpiredResponse: task.allowExpiredResponse,
      files: task.files
    };
    assignmentsDrawerActions.editAssignment(assignment, classroomId, task.id);
  };

  reassign = task => {
    this.props.taskActions.setSelectedTask(task);
    this.props.drawerActions.openDrawerAndSetContent(DRAWER_CONTENTS.ADD_USERS_TO_TASK);
  };
  showDivToPdf = task => {
    document.querySelector(`#task-card-${task.id} .assignment-options`).style.display = 'none';
    document.querySelector(`#task-card-${task.id} .span-arrow-dropdown-list`).style.display = 'none';
    document.querySelector(`#task-card-${task.id} .dropdown-list-elements-container`).style.display = 'block';
    document.querySelector(`#task-card-${task.id} .assignment-title`).style = 'white-space: normal';
  };
  closeDivToPdf = task => {
    document.querySelector(`#task-card-${task.id} .assignment-options`).style.display = 'block';
    document.querySelector(`#task-card-${task.id} .span-arrow-dropdown-list`).style.display = 'flex';
    document.querySelector(`#task-card-${task.id} .assignment-title`).style = 'white-space: nowrap';
    document.querySelector(`#task-card-${task.id} .dropdown-list-elements-container`).style.display = '';
  };
  displayMessage = (message, typemessage) => {
    const { messageAlert } = this.props;
    $('#smartLoader')
      .removeClass('active')
      .removeClass('opaque');
    $('#smartLoader-loader').removeClass('active');
    if (typemessage === 'success') {
      messageAlert.success(message);
    } else {
      messageAlert.info(message);
    }
  };

  exportPdfTask = task => {
    this.showDivToPdf(task);
    let source = document.getElementById(`task-card-${task.id}`);

    let options = {
      margin: [20, 0, 39, 0],
      filename: `${task.name}.pdf`,
      image: { type: 'jpg', quality: 0.98 },
      html2canvas: {
        scale: 2,
        logging: true,
        dpi: 192,
        letterRendering: true,
        useCORS: true
      },
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
    };

    let exporter = new html2pdf(source, options);
    this.displayMessage(I18n.t('tasks.tasksCreatePDF'), 'info');
    exporter.getPdf(true).then(pdf => {
      this.displayMessage(I18n.t('tasks.tasksExportPDF'), 'success');
    });
    this.closeDivToPdf(task);
  };

  exportCSVTask = task => {
    let csvData = task.users.map(item => resultActivitiesStudents(task, item));
    this.displayMessage(I18n.t('tasks.tasksCreateCSV'), 'info');
    const csvExporter = new ExportToCsv({ quoteStrings: '', useKeysAsHeaders: true, filename: task.name });

    csvExporter.generateCsv(csvData);

    this.displayMessage(I18n.t('tasks.tasksExportCSV'), 'success');
  };

  onOpenModal = task => {
    const { taskActions } = this.props;
    taskActions.setModalOpenTask(task);
  };

  getClassroomNameAndColor = task => {
    const { activeClassrooms, classroomId } = this.props;
    let classroomName;
    let classroomColor;

    if (!classroomId) {
      const classrooms = _.filter(activeClassrooms, classroom => {
        return classroom.sectionId === task.parentSection;
      });

      classroomName = classrooms[0] ? classrooms[0].name : '';
      classroomColor = classrooms[0] ? classrooms[0].colour : '';
    }
    return { classroomName, classroomColor };
  };

  renderTasks = tasks => {
    const { inClassroom, classroom, user } = this.props;
    const { classroomsStudents } = this.state;
    let assignmentCards = [];

    if (tasks && tasks.length) {
      tasks.forEach((task, key) => {
        const { classroomName, classroomColor } = this.getClassroomNameAndColor(task);
        const activitiesLength = taskService.getActivitiesWithoutLessons(task.activities).length;
        const groups = task.sections;
        const students = task.users;
        const studentsAssigned = taskService.getStudentsAssigned(task, classroomsStudents);
        const groupedStudents = taskService.setStudentsInGroups(studentsAssigned, task, task.resultSummary);
        const group = groups && groups.length ? _.first(groups) : null;
        const student = students && students.length ? _.first(students) : user;
        const groupName =
          group && group.name !== classroomName && group.id !== classroom.id
            ? groupsApi.getGroupName(group)
            : I18n.t('groups.everyone');
        const groupColor =
          group && group.name !== classroomName && group.id !== classroom.id ? group.colour : undefined;
        const assignedTo = _.isNil(group) ? `${student.name} ${student.surname}` : groupName;
        let grade;
        let totalItemsCompleted;
        let totalItems;
        if (!this.isTeacher()) {
          grade = taskService.getTaskGrade(task, user._id);
          totalItemsCompleted = taskService.getTaskCompletenessForStudent(task.resultSummary);
          totalItems = activitiesLength;
        } else {
          totalItemsCompleted = taskService.getTaskCompletenessForInstructor(task, activitiesLength);
          totalItems = studentsAssigned ? studentsAssigned.length : 0;
        }

        assignmentCards.push(
          <AssignmentCard
            groupName={assignedTo}
            classroomName={classroomName}
            totalItems={totalItems}
            task={task}
            onTime={isFuture(task.dueDate)}
            key={task.id}
            deleteTask={() => this.onOpenModal(task)}
            grade={grade}
            groupColorClass={`group-item-${groupColor}`}
            classroomColorClass={`classroom-color-${classroomColor}`}
            totalItemsCompleted={totalItemsCompleted}
            onClickCard={() => this.togglePanel(task, studentsAssigned)}
            onClickOptions={() => this.toggleEditAssignment(task)}
            pendingGrades={groupedStudents.toReview.length}
            onClickCloseTask={() => this.closeTask(task)}
            onClickReassign={() => this.reassign(task)}
            onClickExportPdfTask={() => this.exportPdfTask(task)}
            onClickExportCSVTask={() => this.exportCSVTask(task)}
            showClassroom={!inClassroom}
          />
        );
      });
    }
    return assignmentCards;
  };

  togglePanel = (task, studentsAssigned) => {
    const { drawerActions, taskActions, role } = this.props;

    taskActions.setSelectedTask(task);
    taskActions.setTaskStudentsAssigned(studentsAssigned);

    if (this.isTeacher()) {
      drawerActions.openDrawerAndSetContent(DRAWER_CONTENTS.STUDENTS_ASSIGNMENT);
    } else if (role === ROLE.STUDENT) {
      drawerActions.openDrawerAndSetContent(DRAWER_CONTENTS.STUDENT_TASK);
    }
  };

  handlePageClick = data => {
    const { classroomId, taskActions, tab, user } = this.props;
    const newPage = data.selected;

    if (tab) {
      switch (tab.key) {
        case TASK_TABS_CONSTANTS.IN_PROGRESS.key:
          taskActions.setCurrentTasksCurrentPage(newPage);
          taskActions.getCurrentAssignments(classroomId, user._id);
          break;
        case TASK_TABS_CONSTANTS.FINISHED.key:
          taskActions.setFinishedTasksCurrentPage(newPage);
          taskActions.getFinishedAssignments(classroomId, user._id);
          break;
        case TASK_TABS_CONSTANTS.FUTURE.key:
          taskActions.setFutureTasksCurrentPage(newPage);
          taskActions.getFutureAssignments(classroomId, user._id);
          break;
        default:
          taskActions.setFilteredTasksCurrentPage(newPage);
          taskActions.getFilteredAssignments(
            classroomId,
            user._id,
            null,
            classroomId ? null : TASK_TABS_CONSTANTS.IN_PROGRESS
          );
          break;
      }
    }
  };

  render() {
    const {
      currentTasks,
      finishedTasks,
      futureTasks,
      filteredTasks,
      tab,
      handleOpenCreateTaskModal,
      classroomId,
      role
    } = this.props;
    const areCurrentTasks = tab.key === TASK_TABS_CONSTANTS.IN_PROGRESS.key;
    const areFinishedTasks = tab.key === TASK_TABS_CONSTANTS.FINISHED.key;
    const areFutureTasks = tab.key === TASK_TABS_CONSTANTS.FUTURE.key;
    let currentPage;
    let tasks;
    let totalPages;
    let isFetching;

    if (areCurrentTasks) {
      isFetching = currentTasks.fetching;
      tasks = this.renderTasks(currentTasks.tasks);
      currentPage = currentTasks.currentPage;
      totalPages = currentTasks.pages;
    } else if (areFinishedTasks) {
      isFetching = finishedTasks.fetching;
      tasks = this.renderTasks(finishedTasks.tasks);
      currentPage = finishedTasks.currentPage;
      totalPages = finishedTasks.pages;
    } else if (areFutureTasks) {
      isFetching = futureTasks.fetching;
      tasks = this.renderTasks(futureTasks.tasks);
      currentPage = futureTasks.currentPage;
      totalPages = futureTasks.pages;
    } else {
      isFetching = filteredTasks.fetching;
      tasks = this.renderTasks(filteredTasks.tasks);
      currentPage = filteredTasks.currentPage;
      totalPages = filteredTasks.pages;
    }

    return (
      <div className="list-container">
        <AssignmentsContent
          classroomId={classroomId}
          tasks={tasks}
          tasksPages={totalPages}
          currentPage={currentPage}
          isFetching={isFetching}
          handlePageClick={this.handlePageClick}
          handleOpenCreateTaskModal={handleOpenCreateTaskModal}
          role={role}
        />
      </div>
    );
  }
}

Assignments.propTypes = {
  classroomId: PropTypes.any,
  classroomActions: PropTypes.object,
  taskActions: PropTypes.object,
  drawerActions: PropTypes.object,
  bookActions: PropTypes.object,
  assignmentsDrawerActions: PropTypes.object,
  classroomGroupsActions: PropTypes.object,
  currentTasks: PropTypes.object,
  finishedTasks: PropTypes.object,
  futureTasks: PropTypes.object,
  filteredTasks: PropTypes.object,
  fileTypeImages: PropTypes.any,
  activeClassrooms: PropTypes.any,
  inClassroom: PropTypes.any,
  classroom: PropTypes.any,
  tab: PropTypes.object,
  user: PropTypes.object,
  keywordsFilter: PropTypes.string,
  datesRangeFilter: PropTypes.object,
  handleOpenCreateTaskModal: PropTypes.func
};

function mapStateToProps(state) {
  return {
    activeClassrooms: state.classrooms.activeClassrooms,
    classroom: state.classrooms.selectedClassroom.classroom,
    currentTasks: state.task.currentTasks,
    finishedTasks: state.task.finishedTasks,
    futureTasks: state.task.futureTasks,
    filteredTasks: state.task.filteredTasks,
    keywordsFilter: state.task.keywordsFilter,
    datesRangeFilter: state.task.datesRangeFilter,
    fileTypeImages: state.theme.images.placeholders.lesson,
    user: state.account.user,
    institution: state.school.school,
    inClassroom: state.router.inClassroom
  };
}

function mapDispatchToProps(dispatch) {
  return {
    classroomActions: bindActionCreators(classroomActions, dispatch),
    bookActions: bindActionCreators(bookActions, dispatch),
    taskActions: bindActionCreators(taskActions, dispatch),
    drawerActions: bindActionCreators(drawerActions, dispatch),
    assignmentsDrawerActions: bindActionCreators(assignmentsDrawerActions, dispatch),
    classroomGroupsActions: bindActionCreators(classroomGroupsActions, dispatch),
    messageAlert: bindActionCreators(messageAlert, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Assignments);
